function hidePopupFunction(){
  window.location.href = "about:blank"; 
  window.close();
}

import React, { useEffect, useState } from 'react';
// const hidePopupFunction = ()=>{
//  // window.close();
//  window.open("http://localhost:3000/index.html", "_self", "");
//  window.close()
// }
const NotificationPage = ({ closePopup }) => {
  const [showPopup, setShowPopup] = useState(true);
  
  const popupFunction = ()=>{
    if(document.getElementById("myCheck").checked === true){
      setShowPopup(false)
  }
}


  useEffect(() => {
    //Runs only on the first render
  }, [showPopup]);
  return (
    
    
    <div>
    {showPopup &&  <div className="popup">
      <div className="popup-content">
        <h1 style={{color:'Red', alignContent:'center'}}>This website is for law enforcement personnel only.</h1><br></br>
        <div className="popup-ptext">By clicking on the “I Agree” button below, I certify under penalty of perjury that I am a current active employee of a federal, state or local law enforcement agency or prosecutor’s office.  I also consent to the collection of my email address for employment verification. </div><br></br>
        <input type="checkbox" id="myCheck"/>
        <label  style={{fontSize:'larger'}}for="vehicle1"> I Agree</label><br></br><br></br>
        <div style={{display: 'flex'}}>
        <button className="popup-button" onClick={popupFunction}>Continue</button>
        <button className="popup-button" onClick={hidePopupFunction}>Exit</button>
        </div>
      </div>
     {/* {popupFunction} */}
     
    </div>}
    </div>
  );
};

export default NotificationPage;